import { faCreditCard } from '@fortawesome/pro-light-svg-icons';
import { CardNumberElement } from '@stripe/react-stripe-js';
import { StripeCardNumberElementChangeEvent } from '@stripe/stripe-js';
import React from 'react';
import BaseStripeCardInput from './BaseStripeCardInput';
import { getStripeElementStyles } from './stripeStyles';

interface CardNumberInputProps {
  disabled?: boolean;
  error?: string;
  onError?: (error: string | undefined) => void;
  onComplete?: (complete: boolean) => void;
  label?: string;
  withAsterisk?: boolean;
}

const CardNumberInput: React.FC<CardNumberInputProps> = ({
  disabled = false,
  error,
  onError,
  onComplete,
  label = 'Card Number',
  withAsterisk = false,
}) => {
  const handleChange = (event: StripeCardNumberElementChangeEvent) => {
    if (onError) {
      onError(event.error?.message);
    }
    if (onComplete) {
      onComplete(event.complete);
    }
  };

  return (
    <BaseStripeCardInput
      label={label}
      withAsterisk={withAsterisk}
      disabled={disabled}
      error={error}
      icon={faCreditCard}
    >
      <CardNumberElement
        options={{
          placeholder: '0000 0000 0000 0000',
          disabled,
          style: getStripeElementStyles(disabled),
        }}
        onChange={handleChange}
      />
    </BaseStripeCardInput>
  );
};

export default CardNumberInput;
